import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ensureNewsletterAdminAccess } from "@/lib/auth/newsletter-admin.guard";

export const Route = createFileRoute("/admin/newsletter/newsletters")({
  beforeLoad: () => ensureNewsletterAdminAccess(),
  component: () => <Outlet />,
});
